import { connect } from "react-redux";
import { list_orders } from "../../redux/actions/orders";
import { get_items, get_total, get_item_total } from "../../redux/actions/cart";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import SideNav from "../../components/dashboard/Sidebar";

const userNavigation = [
  { name: "Your Profile", href: "#" },
  { name: "Sign Out", href: "#" },
];

const Dashboard = ({
  list_orders,
  get_items,
  get_total,
  get_item_total,
  isAuthenticated,
  user,
}) => {
  useEffect(() => {
    get_items();
    get_total();
    get_item_total();
    list_orders();
  }, [get_items, get_total, get_item_total, list_orders]);

  if (!isAuthenticated) return <Navigate to="/" />;

  return (
    <SideNav user={user} userNavigation={userNavigation}>
      <main className="flex-1">
        <div className="py-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto">
              <div>
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                  Personal Information
                </h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500">
                  This information will be visible to other users on the
                  platform.
                </p>
              </div>
              <div className="mt-5 border-t border-gray-200">
                <dl className="divide-y divide-gray-200">
                  <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
                    <dt className="text-sm font-medium text-gray-500">
                      Full Name
                    </dt>
                    <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      <span className="flex-grow">
                        {user && user.first_name} {user && user.last_name}
                      </span>
                    </dd>
                  </div>

                  <div className="py-4 sm:grid sm:py-5 sm:grid-cols-3 sm:gap-4">
                    <dt className="text-sm font-medium text-gray-500">Email</dt>
                    <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      <span className="flex-grow">{user && user.email}</span>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </main>
    </SideNav>
  );
};

const mapStateToProps = (state) => ({
  orders: state.Orders.orders,
  isAuthenticated: state.Auth.isAuthenticated,
  user: state.Auth.user,
});

export default connect(mapStateToProps, {
  list_orders,
  get_items,
  get_total,
  get_item_total,
})(Dashboard);
